// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"8cdbd947","257":"740db18c","400":"202b809b","453":"13316d7a"}[chunkId] + ".chunk.js";
};